module.exports = __webpack_public_path__ + "media/images/slide-24-f99795a8ecf59eafa447f7a625aa9a71.jpg";